import { render, staticRenderFns } from "./AppSplashscreen.vue?vue&type=template&id=0fefcf6b&"
import script from "./AppSplashscreen.vue?vue&type=script&lang=js&"
export * from "./AppSplashscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports